// extracted by mini-css-extract-plugin
module.exports = {"header":"infoBus_header__toPNj","chofer":"infoBus_chofer__2N_eH","configuration":"infoBus_configuration__2Q6OV"};